<template>
  <div class="container-cap" id="members" v-if="surveillance != null">
    <h2>
      {{ title }}
      <span class="label" :class="`label-${module}`">
        {{ modules[module].label }}
      </span>
    </h2>
    <hr>
    <div v-if="year === '2019'">
      <sui-members-table-2019 :surveillance="surveillance"
         :roles="roles"
         :module="module">
      </sui-members-table-2019>
      <h3>Rôles et droits d'accès</h3>
      <div class="row">
        <div class="col-xs-12">
          <table class="table table-responsive">
            <thead>
              <tr class="info">
                <th>Action</th>
                <th v-for="r in roles"
                    :key="`referents-roles-header-${r.value}`">
                  {{ r.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="a in authorizations"
                  :key="`referents-authz-${a.field}`">
                <td>{{ a.name }}</td>
                <td v-for="r in roles"
                    :key="`referents-role-${r.value}-authz-${a.field}`">
                  <span v-if="r[a.field]"
                        class="glyphicon glyphicon-ok text-success"
                        aria-hidden="true">
                  </span>
                  <span v-else
                        class="glyphicon glyphicon-remove text-danger"
                        aria-hidden="true">
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else>
      <sui-members-table :surveillance="surveillance" :module="module">
        <span v-if="isResults">
          <h3>Ajouter un destinataire des résultats</h3>
          <hr>
          <div class="row">
            <div class="col-xs-12 col-md-8 text-justify">
              <alert type="warning">
                <p>
                  Cette section vous permet d'ajouter un accès à la partie
                  <strong>HORS DONNÉES DE SANTÉ</strong> des résultats.
                </p>
                <p>
                  Cet accès est à destination du personnel
                  <strong>NON MÉDICAL</strong>.
                </p>
                <p>
                  Devenir «Destinataire des résultats» permet d'accéder :
                  <ul>
                    <li>
                      Aux tableaux de taux d'incidence des bactériémies et des
                      pneumopathies pour tout l'établissement
                    </li>
                    <li>
                      Aux graphiques de réparatition des taux d'incidence des
                      bactériémies et des pneumopathies
                    </li>
                  </ul>
                </p>
              </alert>
              <alert type="warning">
                <p>
                  Pour donner un accès complet (<strong>AVEC DONNÉES DE SANTÉ</strong>)
                  aux résultats d'une modalité, il vous faut ajouter la personne
                  en tant que membre de cette modalité puis lui donner la
                  permission «Résultats».
                </p>
              </alert>
            </div>
          </div>
        </span>
      </sui-members-table>
    </div>
  </div>
</template>
<script>
import suiMembersTable2019 from '@/sui/components/members/table2019'
import suiMembersTable from '@/sui/components/members/table'
import modules from '@/sui/data/modules'

import { mapGetters } from 'vuex'

export default {
  name: 'referents',

  data: function () {
    return {
      authorizations: [
        {
          name: 'Saisie des fiches',
          field: 'forms'
        },
        {
          name: 'Exploration des données',
          field: 'data'
        },
        {
          name: 'Suppression des fiches',
          field: 'remove'
        },
        {
          name: 'Validation des fiches',
          field: 'validate'
        },
        {
          name: 'Gestion des membres',
          field: 'members'
        },
        {
          name: 'Saisie de la fiche établissement',
          field: 'establishment'
        },
        {
          name: `Envoi de la charte d'engagement`,
          field: 'convention'
        }
      ],

      roles: [
        {
          name: 'Responsable',
          value: -1,
          members: true,
          forms: true,
          validate: true,
          remove: true,
          establishment: true,
          convention: true,
          data: true,
          selectable: false
        },
        {
          name: 'Référent.e',
          value: 0,
          members: true,
          forms: true,
          validate: true,
          remove: true,
          data: true,
          establishment: false,
          convention: false,
          selectable: true
        },
        {
          name: 'Opérateur.rice de saisie',
          value: 1,
          members: false,
          forms: true,
          validate: false,
          remove: true,
          data: false,
          establishment: false,
          convention: false,
          selectable: true
        },
        {
          name: 'Destinataire des résultats',
          value: 2,
          members: false,
          forms: false,
          validate: false,
          remove: false,
          data: true,
          establishment: false,
          convention: false,
          selectable: true
        }
      ],

      add: {
        alert: { type: '', text: '', title: '' },
        userEmail: null,
        userRole: null
      },
      remove: {
        referent: null
      },
      removeModal: false
    }
  },

  computed: {
    ...mapGetters({
      get: 'surveillances/get'
    }),

    modules: function () {
      return modules[this.year]
    },

    module: function () {
      return this.$route.params.st
    },

    year: function () {
      return this.$route.params.year
    },

    surveillance: function () {
      return this.get(this.year, this.$route.params.id)
    },

    isResults: function () {
      return this.module === 'results'
    },

    title: function () {
      if (this.isResults) {
        return 'Destinataire des'
      }

      return 'Membres'
    }
  },

  components: {
    'sui-members-table': suiMembersTable,
    'sui-members-table-2019': suiMembersTable2019
  }
}
</script>
<style scoped lang="less">
h3 {
  margin-top: 4rem;
}
</style>
